import React from "react";
import moment from "moment";
import escapeHtml from "escape-html";
import IntlMessageFormat from "intl-messageformat";
import { getCookie, writeCookie } from "core/common/utils/storage";
import { getDescendantProp } from "core/common/utils/jsonUtils";

import "moment/locale/cs";
import "moment/locale/sk";
import "moment/locale/de";
import "moment/locale/hu";
import "moment/locale/pl";
import "moment/locale/ro";
import "moment/locale/uk";

import momentLocalizer = require("react-widgets/lib/localizers/moment");

//require('intl/locale-data/jsonp/en.js');

// locale data
const locales = {
  en: require("core/common/locales/en.json"),
  cs: require("core/common/locales/cs.json"),
  sk: require("core/common/locales/sk.json"),
  de: require("core/common/locales/de.json"),
  hu: require("core/common/locales/hu.json"),
  pl: require("core/common/locales/pl.json"),
  ro: require("core/common/locales/ro.json"),
  uk: require("core/common/locales/uk.json"),
};

console.log(locales);

momentLocalizer(moment);

moment.updateLocale("en", {
  longDateFormat: {
    L: "DD/MM/YYYY",
    l: "D/M/YYYY",
    LT: "HH:mm",
    LTS: "HH:mm:ss",
    LL: "D MMMM YYYY",
    ll: "D MMM YYYY",
    LLL: "D MMMM YYYY HH:mm",
    lll: "DD/MM/YYYY HH:mm",
    LLLL: "dddd, D MMMM YYYY HH:mm",
  },
});

// editovane lll kvuli datetimepicker s casem
moment.updateLocale("cs", {
  longDateFormat: {
    L: "DD.MM.YYYY",
    l: "D. M. YYYY",
    LT: "H:mm",
    LTS: "H:mm:ss",
    LL: "D. MMMM YYYY",
    ll: "D. MMM YYYY",
    LLL: "D. MMMM YYYY H:mm",
    lll: "DD.MM.YYYY HH:mm",
    LLLL: "dddd D. MMMM YYYY H:mm",
  },
});

moment.updateLocale("sk", {
  longDateFormat: {
    L: "DD.MM.YYYY",
    l: "D. M. YYYY",
    LT: "H:mm",
    LTS: "H:mm:ss",
    LL: "D. MMMM YYYY",
    ll: "D. MMM YYYY",
    LLL: "D. MMMM YYYY H:mm",
    lll: "DD.MM.YYYY HH:mm",
    LLLL: "dddd D. MMMM YYYY H:mm",
  },
});

moment.updateLocale("ro", {
  longDateFormat: {
    L: "DD.MM.YYYY",
    l: "D. M. YYYY",
    LT: "H:mm",
    LTS: "H:mm:ss",
    LL: "D. MMMM YYYY",
    ll: "D. MMM YYYY",
    LLL: "D. MMMM YYYY H:mm",
    lll: "DD.MM.YYYY HH:mm",
    LLLL: "dddd D. MMMM YYYY H:mm",
  },
});

moment.updateLocale("pl", {
  longDateFormat: {
    L: "DD.MM.YYYY",
    l: "D. M. YYYY",
    LT: "H:mm",
    LTS: "H:mm:ss",
    LL: "D. MMMM YYYY",
    ll: "D. MMM YYYY",
    LLL: "D. MMMM YYYY H:mm",
    lll: "DD.MM.YYYY HH:mm",
    LLLL: "dddd D. MMMM YYYY H:mm",
  },
});

moment.updateLocale("uk", {
  longDateFormat: {
    L: "DD.MM.YYYY",
    l: "D. M. YYYY",
    LT: "H:mm",
    LTS: "H:mm:ss",
    LL: "D. MMMM YYYY",
    ll: "D. MMM YYYY",
    LLL: "D. MMMM YYYY H:mm",
    lll: "DD.MM.YYYY HH:mm",
    LLLL: "dddd D. MMMM YYYY H:mm",
  },
});

moment.updateLocale("de", {
  longDateFormat: {
    L: "DD.MM.YYYY",
    l: "D. M. YYYY",
    LT: "H:mm",
    LTS: "H:mm:ss",
    LL: "D. MMMM YYYY",
    ll: "D. MMM YYYY",
    LLL: "D. MMMM YYYY H:mm",
    lll: "DD.MM.YYYY HH:mm",
    LLLL: "dddd D. MMMM YYYY H:mm",
  },
});

moment.updateLocale("hu", {
  longDateFormat: {
    L: "YYYY.MM.DD",
    l: "YYYY M. D.",
    LT: "H:mm",
    LTS: "H:mm:ss",
    LL: "YYYY MMMM D.",
    ll: "YYYY MMM D.",
    LLL: "YYYY MMMM D. H:mm",
    lll: "YYYY.MM.DD HH:mm",
    LLLL: "YYYY MMMM dddd D. H:mm",
  },
});

moment.relativeTimeThreshold("M", 12);

// aby byl moment dostupny v uzivatelsky definovanych eval vyrazech defaultnich hodnot policek (v MdEntity#initDefaultValues())
window.moment = moment;

class Loc {
  private _lang: string;
  public available: string[];
  public countries: { [language: string]: string };
  public defaultLang: string;

  private messageFormatCache: Map<string, IntlMessageFormat> = new Map();

  constructor() {
    this.available = ["en", "cs", "de", "hu", "pl", "ro", "sk", "uk"];
    this.countries = {
      en: "gb",
      cs: "cz",
      de: "de",
      hu: "hu",
      pl: "pl",
      ro: "ro",
      sk: "sk",
      uk: "ua",
    };
    this._lang = null;
    this.defaultLang = "en";
  }

  get lang() {
    if (!this._lang) {
      this._lang = this.resolveLang();
      moment.locale(this._lang);
    }
    return this._lang;
  }

  set lang(_l) {
    if (this.available.includes(_l)) {
      this._lang = _l;
      writeCookie("lang", _l, 365);
      moment.locale(_l);
    }
  }

  get country() {
    return this.countries[this.lang];
  }

  /**
   * Nejdriv to zkusim vzit z cookie
   * @returns {*}
   * @private
   */
  private resolveLang(): string {
    console.debug("resolving lang ");

    let _l = getCookie("lang");
    if (_l) {
      if (this.available.includes(_l)) {
        return _l;
      }
    }
    let nav = window.navigator;
    let locale = nav.language || "";
    _l = locale.slice(0, 2);
    if (this.available.includes(_l)) {
      return _l;
    } else {
      return "en";
    }
  }

  /**
   * Get the formatted message by key
   * @param {string} key The string representing key in locale data file
   * @param {Object} variables Variables in message
   * @returns {string} message
   */
  get(key: string, variables?: object): string {
    let la = this.lang;

    if (!locales[la]) {
      return key;
    }
    let msg = getDescendantProp(locales[la], key);
    if (msg == null) {
      msg = getDescendantProp(locales["en"], key);
    }
    if (msg == null) {
      console.error(`localization key "${key}" not defined in ${la}`);
      return key;
    }
    if (variables) {
      variables = Object.assign({}, variables);
      // HTML message with variables. Escape it to avoid XSS attack.
      for (let i in variables) {
        let value = variables[i];
        if (
          typeof value === "string" &&
          value.indexOf("<") >= 0 &&
          value.indexOf(">") >= 0
        ) {
          value = escapeHtml(value);
        }
        variables[i] = value;
      }
    }

    return this.format(msg, variables, la);
  }

  private format(msg: string, variables, la: string) {
    try {
      let intlMessageFormat = this.messageFormatCache.get(msg);
      if (!intlMessageFormat) {
        intlMessageFormat = new IntlMessageFormat(msg, la); // TODO memorize
        this.messageFormatCache.set(msg, intlMessageFormat);
      }
      msg = intlMessageFormat.format(variables);
      return msg;
    } catch (err) {
      console.error(
        `localization format message failed for message='${msg}'`,
        err
      );
      return msg;
    }
  }

  /**
   * Get the formatted html message by key.
   * @param {string} key The string representing key in locale data file
   * @param {Object} variables Variables in message
   * @returns {React.Element} message
   */
  getHTML(key: string, variables: object): any {
    let msg = this.get(key, variables);

    return msg != null
      ? React.createElement("span", {
          dangerouslySetInnerHTML: {
            __html: msg,
          },
        })
      : key;
  }

  /**
   * use {@link get()}
   */
  i18n(strings : TemplateStringsArray, ...values) {
    let la = this.lang;

    let str = "";
    for (let i = 0; i < strings.length - 1; i++) {
      str += strings[i] + "{" + i + "}";
    }
    str += strings[strings.length - 1];

    str = this.readTransByLang(str, la);

    return this.format(str, values, la);
  }

  private readTransByLang(str : string, lang : string) {
    let messages = locales[lang];
    if (messages) {
      let trans = messages[str];

      return trans ? trans : this.getDefaultTrans(str);
    }

    return this.getDefaultTrans(str);
  }

  private getDefaultTrans(str : string) {
    let messages = locales[this.defaultLang];
    let trans = messages[str];
    if (!trans) {
      trans = str;
    }

    return trans;
  }
}

export const loc = new Loc();

export function changeLanguage(lang: string, event: any) {
  console.log("onSelectLanguage: event = %o, lang = %o", event, lang);
  if (event) event.preventDefault();
  loc.lang = lang;
  window.localStorage.clear();
  window.location.reload(true);
}



// WEBPACK FOOTER //
// ./src/core/common/config/locales.ts